/**
 * @generated SignedSource<<0ad35c8f1f98878d800c79bb86034153>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RemoveAttachmentsMutationInput = {
  clientMutationId?: string | null;
  ids: ReadonlyArray<string>;
};
export type PostDraftInstagramRemoveMutation$variables = {
  input: RemoveAttachmentsMutationInput;
};
export type PostDraftInstagramRemoveMutation$data = {
  readonly removeAttachments: {
    readonly __typename: "Attachments";
    readonly attachments: ReadonlyArray<{
      readonly id: string;
    }>;
  } | {
    readonly __typename: "RemoveAttachmentsError";
    readonly message: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type PostDraftInstagramRemoveMutation = {
  response: PostDraftInstagramRemoveMutation$data;
  variables: PostDraftInstagramRemoveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "removeAttachments",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Attachment",
            "kind": "LinkedField",
            "name": "attachments",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "type": "Attachments",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "type": "RemoveAttachmentsError",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PostDraftInstagramRemoveMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PostDraftInstagramRemoveMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8795634f68e1573146780b19c6b30a51",
    "id": null,
    "metadata": {},
    "name": "PostDraftInstagramRemoveMutation",
    "operationKind": "mutation",
    "text": "mutation PostDraftInstagramRemoveMutation(\n  $input: RemoveAttachmentsMutationInput!\n) {\n  removeAttachments(input: $input) {\n    __typename\n    ... on Attachments {\n      attachments {\n        id\n      }\n    }\n    ... on RemoveAttachmentsError {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fcaf04e4f98f236339c4bcb4afd8cba2";

export default node;
